import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import WebDatatable from 'app/shared/datatable/web/datatable';
import MobileDatatable from 'app/shared/datatable/mobile/datatable';
import { formatDateForDisplay } from 'app/shared/utils/date';
import { GridColumn, GridRow } from 'app/member/layouts/grid';
import { useSenderIDService } from 'hooks/api/messaging/sender-id';

export const SenderIDListPage = () => {
  const { is_mobile_view } = useSelector((state) => state.metadata);
  const { updateSenderId, fetchSenderIds } = useSenderIDService();

  const [sender_ids, setSenderIds] = useState({});
  const [loading, setLoading] = useState(false);
  const [total_sender_ids, setTotalSenderIds] = useState(0);

  const config = {
    actions: {
      single: () => [
        [
          { label: 'Mark as verified', value: 'verify' },
          { label: 'Mark as rejected', value: 'reject' }
        ]
      ]
    },
    css: {},
    fields: [
      {
        title: 'Sender ID',
        key: 'sender_id',
        isTitle: true
      },
      {
        title: 'Company Name',
        key: 'company_name'
      },
      {
        title: 'Use Case',
        key: 'use_case'
      },
      {
        title: 'Time sent',
        key: 'time_stamp',
        isMetadata: true,
        formatter: (value) => formatDateForDisplay(value)
      },
      {
        title: 'Status',
        key: 'status'
      }
    ],
    items: Object.values(sender_ids).sort((a, b) => b.time_stamp - a.time_stamp),
    search_key: 'sender_id, company_name',
    search_text: ''
  };

  const handleDatatableAction = (payload) => {
    const { name, type, data } = payload;

    if (type === 'single') {
      switch (name) {
        case 'verify':
          updateStatus(data.id, 'granted');
          break;
        case 'reject':
          updateStatus(data.id, 'rejected');
          break;
        default:
      }
    }
  };

  const handleDataRequest = async (page, population = 10) => {
    if (loading) return;
    setLoading(true);

    const { sender_ids: s_ids, size } = await fetchSenderIds({
      query_string: `page=${page}&population=${population}`
    });

    setSenderIds(() => s_ids.reduce((s, a) => ({ ...s, [a.time_stamp]: a }), {}));
    setTotalSenderIds(() => size);

    setLoading(false);
  };

  const updateStatus = async (id, status = '') => {
    await updateSenderId(id, { data: { status } });
  };

  return (
    <GridRow>
      <GridColumn span={4}>
        {is_mobile_view ? (
          <MobileDatatable
            config={config}
            action={() => {}}
            onClick={() => {}}
            onListModeChange={() => {}}
            onDataRequest={handleDataRequest}
            onSearchRequest={() => {}}
            showHeader
          />
        ) : (
          <WebDatatable
            config={{
              ...config,
              total_count: total_sender_ids
            }}
            action={handleDatatableAction}
            onClick={() => {}}
            checkbox
            loading_data={loading}
            table_actions={[]}
            onDataRequest={handleDataRequest}
            onSearchRequest={() => {}}
          />
        )}
      </GridColumn>
    </GridRow>
  );
};
